export const loadOneTrustSnippet = () => {
    // Load OneTrust snippet
    if (!document.getElementById("onetrust-snippet")) {
        const script = document.createElement("script");
        script.src = ONE_TRUST_SNIPPET_SCRIPT;
        script.setAttribute("data-document-language", true);
        script.type = "text/javascript";
        script.charset = "UTF-8";
        script.setAttribute("data-domain-script", ONE_TRUST_SNIPPET_DOMAIN);
        script.setAttribute("id", "onetrust-snippet");
        document.head.appendChild(script);
    }
    if (!document.getElementById("onetrust-snippet-2")) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.setAttribute("id", "onetrust-snippet-2");
        script.text = `
            function OptanonWrapper() {        
                var event = new Event('bannerLoaded');
                window.dispatchEvent(event);
            }
        `;
        document.head.appendChild(script);
    }
    if (!document.getElementById("onetrust-snippet-3")) {
        const script = document.createElement("script");
        script.src = ONE_TRUST_SNIPPET_CUSTOM_SCRIPT;
        script.type = "text/javascript";
        script.setAttribute("id", "onetrust-snippet-3");
        document.head.appendChild(script);
    }
};
